module.exports = __webpack_public_path__ + "static/media/Rat.64aedbcd.glb";